import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import resources from "./locales";
// declare custom type options so the return is always a string.

declare module "i18next" {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

i18n
  .use(backend)
  .use(detector)
  .use(initReactI18next)
  .init({
    returnNull: false,
    resources,
    load: "languageOnly", // Ignore country
    fallbackLng: ["en", "es"],
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

// Keep <html lang> in sync so browsers don't treat Spanish pages as English and offer translation
const syncDocumentLang = (lng?: string) => {
  if (lng) document.documentElement.lang = lng.split("-")[0];
};
syncDocumentLang(i18n.resolvedLanguage || i18n.language);
i18n.on("languageChanged", syncDocumentLang);

export default i18n;
